/* eslint-disable prettier/prettier */  


import { Box, FormGroup, FormLabel, Typography } from "@mui/material";
import { ChangeEvent } from "react";
import { Control, FieldValues, Path } from "react-hook-form/dist/types";
import { Link } from "react-router-dom";
import FormCheckbox from "./FormCheckbox";
import Translate from "./Translate";

interface ITermsOfUseProps<TFieldValues extends FieldValues = FieldValues> {
  id?: string;
  fieldName?: Path<TFieldValues> | undefined;
  fieldControl?: Control<TFieldValues, any> | undefined;
  onChange?: ((event: ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined;
}

export default function TermsOfUse<TFieldValues extends FieldValues = FieldValues>({
  id,
  fieldName,
  fieldControl,
  onChange
}: ITermsOfUseProps<TFieldValues>) {
  return (
    <Box>
      <FormLabel htmlFor="termsAccepted">
        <Typography variant="body2">
          <Translate src="form:terms_of_use" />
        </Typography>
      </FormLabel>

      <FormGroup>
        <FormCheckbox
          id={id ?? "termsAccepted"}
          fieldControl={fieldControl}
          fieldName={(fieldName ?? "termsAccepted") as typeof fieldName}
          onChange={onChange}
          label={
            <Typography
              sx={{
                color: "inherit",
                fontSize: "1em",
                fontWeight: 600,
                textAlign: "left",
                lineHeight: 1.6,
                marginBottom: "-1px"
              }}
            >
              <Translate
                src="validation:terms_of_use"
                components={{
                  // terms of use
                  "1": (
                    <Link to="https://bizpik.com.br/terms" target="_blank" className="font-bold border-b-2 border-b-inherit pb-[2px]" />
                  ),

                  // privacy policy
                  "2": (
                    <Link to="https://bizpik.com.br/policy" target="_blank" className="font-bold border-b-2 border-b-inherit pb-[2px]" />
                  )
                }}
              />
            </Typography>
          }
        />
      </FormGroup>
    </Box>
  );
}
